<template>
    <Virtual></Virtual>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const Virtual = defineAsyncComponent(() =>
    import("../../../components/ITDepartment/RemoteWorking/Virtual.vue")
);

export default {
    name: "Virtual_Office",
    components: { Virtual, AuthLayout },
};
</script>
